import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToElement, waitForElement } from "./utils";

/*
 This component doesn't render anything, it just listens for changes to the `location.hash` (or looks for a
 hash already in the url) and tries to find the DOM node with an `id` of the hash, and scrolls to it (you
 know, like would normally happen without react-router).

 For background, it seems like this was always dealt with outside of react-router using
 https://github.com/rafgraph/react-router-hash-link, but it has some problems with react-router v6
 (in our case, it was leading to the warning `React does not recognize the `isActive` prop on a DOM element.`

 Based on:
   - https://github.com/ncoughlin/scroll-to-hash-element
   - https://ncoughlin.com/posts/react-router-v6-hash-links/
 */
const ScrollToHashElement = (): React.ReactElement => {
  const location = useLocation();

  // If the element isn't present when this component is mounted, wait for it.
  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      waitForElement(hash).then((targetElement) => {
        scrollToElement(targetElement);
      });
    }
  }, []);

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const maybeElement = document.querySelector(hash);
      if (maybeElement) {
        scrollToElement(maybeElement);
      }
    }
  }, [location]);

  return null;
};

export default ScrollToHashElement;
